import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  USER_ROLE_EDIT,
  USER_ROLE_UPDATE
} from "../../routes/routes";
import { toast } from "react-toastify";
import { FullPageLoader } from '../../components/common/Loader'; // Import the loader component
import { USER_ROLE_UPDATED } from "../../constant/constant";

const UserRoleEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState();
  const [errors, setErrors] = useState({});

  /**   *
   * @param {*} input
   * @param {*} callback
   */


  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(USER_ROLE_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(USER_ROLE_UPDATED);
          navigate("/user-roles");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios.get(USER_ROLE_EDIT + id).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          id: responseData?.id,
          role_name: responseData?.role_name,
          status: responseData?.status
        });
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">User Roles</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/user-roles"}>
                    <span>User Roles List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit User Role</span></li>
              </ol>

            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/user-roles"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit User Role</h5> */}
              </div>
              <div className="card-body app-form-fields">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="role_name"
                        >
                          Role Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="role_name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, role_name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, role_name: e.target.value })
                          }
                          defaultValue={form?.role_name}
                        />
                        <ValidationMessage error={errors} name="role_name" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/user-roles"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRoleEdit;
